export enum BoxAuditModal {
  BOX_AUDIT_UNEXPECTED_SKU = "BOX_AUDIT_UNEXPECTED_SKU",
  BOX_AUDIT_ERROR = "BOX_AUDIT_ERROR",
  BOX_AUDIT_INPUT_BARCODE_MODAL = "BOX_AUDIT_INPUT_BARCODE_MODAL",
  BOX_AUDIT_QUIT = "BOX_AUDIT_QUIT",
  BOX_AUDIT_PRINT_LABEL = "BOX_AUDIT_PRINT_LABEL",
  BOX_AUDIT_ACCURATE_LABEL = "BOX_AUDIT_ACCURATE_LABEL",
}
